import {
  Component,
  OnInit
} from '@angular/core';
import { SohoButtonComponent } from 'ids-enterprise-ng';
import { LMLoggerService } from '@services/lm-logger.service';

@Component({
  selector:    'lm-login-component',
  standalone: false,
  templateUrl: './lm-login.component.html',
  styleUrls:   [ 'lm-login.component.scss' ]
})
export class LMLoginComponent implements OnInit {

  private applicationName = Soho.Locale.translate('ApplicationName');
  private buttonType = SohoButtonComponent.PRIMARY;
  private submitText = Soho.Locale.translate('Submit');

  forgotPasswordText = Soho.Locale.translate('ForgotPassword');
  userNameText = Soho.Locale.translate('Username');
  passwordText = Soho.Locale.translate('Password');
  model = {
    userName: null,
    password: null
  };

  constructor(private lmLoggerService: LMLoggerService) { }

  public getUserName() {
    return this.model.userName;
  }

  public getPassword() {
    return this.model.password;
  }

  // events
  ngOnInit() {}

  submitLogin() {
    // this.lmLoggerService.log('User Name: ' + this.model.userName + ' Password: ' + this.model.password);
  }
}
